import './Home.css';

import React, { Component } from 'react';
import { Table } from 'reactstrap';

import UserList from '../../components/UserList/UserList';
import userService from '../../services/user';
import caseService from '../../services/cases';
import CaseList from '../../components/CaseList/CaseList';

export default class Home extends Component {

  constructor() {
    super();
    this.state = {
      users: [],
      nonValidatedUsers: []
    }
  }
  async componentDidMount() {
    this.setState({
      users: await userService.getUnapprovedUsers(),
      nonValidatedUsers: await userService.getNonValidatedUsers(),
      cases: await caseService.getActiveCases()
    });
  }

  render () {
    
    const { users, cases, nonValidatedUsers } = this.state;
    
    return (
      <div className="staffHome">
        <label>Non Validated Users:</label>
        { nonValidatedUsers && nonValidatedUsers.length > 0 ?
          <Table>
            <thead>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              { nonValidatedUsers.map( (u, i) => (
                <tr key={ `non-validated-user-${ u.UserId || i }` }>
                  <td>{ u.FirstName }</td>
                  <td>{ u.LastName }</td>
                  <td>{ u.EmailAddress }</td>
                </tr>
              )) }
            </tbody>
          </Table>
          :
          <div className="alert alert-success">None!</div>
        }
        <label>Users pending approval:</label>
        { users && users.length > 0 ?
          <UserList users={users || []} />
          :
          <div className="alert alert-success">None!</div>
        }
        <label>Active cases:</label>
        <CaseList cases={cases || []} />
      </div>
    );
  }
}
